import { useNavigate } from "react-router-dom";
import { Dataset } from "./api/Application";
import { Card, Col, Container, Row } from "react-bootstrap";
import { Button } from "./components/Button";
import { BsFolder2Open } from "react-icons/bs";

export function DatasetStats( { dataset }: { dataset: Dataset } ) {
    const nav = useNavigate();
    const imageCount = dataset.count;
    return (
        <Container fluid className="p-4">
            <Row>
                <Col xs={8}>
                    <div className="d-flex align-items-center gap-2">
                        <div className="fs-3">
                            {dataset.name}
                        </div>
                    </div>
                    {dataset.description && (
                        <div className="text-muted">{dataset.description}</div>
                    )}
                    <div className="d-flex flex-column gap-1 w-25">
                        <Button variant="primary" className="gap-2 d-flex align-items-center"
                            onClick={() => nav( `/dataset/${dataset.datasetId}` )}>
                            <BsFolder2Open />
                            View Images
                        </Button>
                        {/* <Button variant="primary" className="gap-2 d-flex align-items-center"
                            onClick={() => nav( `/dataset/${dataset.datasetId}` )}>
                            <BsFolder2Open />
                            View Attribute Classes
                        </Button> */}
                    </div>
                </Col>
                <Col xs={4}>
                    
                </Col>
            </Row>
        </Container>
    );
}

export function StatCards( dataset: Dataset ) {
    
    const stats = [
        { label: "Images",       value: dataset.count, gradient: "linear-gradient(135deg, #7B2FF7, #C471F5)" },
        // { label: "Annotations",  value: dataset.,          gradient: "linear-gradient(135deg, #2BC0E4, #EAECC6)" },
        // { label: "Reviewed",     value: 6210,          gradient: "linear-gradient(135deg, #F7971E, #FFD200)" },
        // { label: "Completed",    value: "74%",         gradient: "linear-gradient(135deg, #FC5C7D, #6A82FB)" },
    ];

    return (
        <Row className="g-3">
            {stats.map(s => (
                <Col key={s.label}>
                    <Card
                        className="border-0 text-white"
                        style={{
                            background: s.gradient,
                            borderRadius: "1rem",
                        }}
                    >
                        <Card.Body>
                            <div className="small opacity-75">{s.label}</div>
                            <div className="fs-3 fw-bold">{s.value}</div>
                        </Card.Body>
                    </Card>
                </Col>
            ))}
        </Row>
    );
}